export default __webpack_public_path__ + "static/media/multi-purpose.cca2b8bb.png";